module.exports = ".classbtn{\r\n    border: 1px solid #1c8312;\r\n    color: #1c8312\r\n}\r\n.classbtn:hover, .active{\r\n    background-color: #1c8312!important;\r\n    color: #fff\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/frontend/library/library.component.css
// module id = ./src/app/frontend/library/library.component.css
// module chunks = frontend.module